export default __webpack_public_path__ + "static/media/loader.27799254.svg";